<template>
    <div>
        <!-- 注册账号 -->
        <div class="document-container">
            <h2>登录注册账号</h2>
            <p>访问专加瓦平台官网<el-link href="https://www.ipjava.cn/" target="_blank"
                    type="primary">https://www.ipjava.cn/</el-link>。</p>
            <p>使用中国大陆手机号完成验证码注册。</p>
            <p>输入注册的手机号与验证码。</p>
            <p>点登录，完成账号创建。</p>
            <div class="imageInfo">
                <img src="@/assets/userBook/image23.png" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RegisterAccount',
    data() {
        return {

        }
    },
    methods: {

    },
    mounted() {

    },
    beforeDestroy() {

    }
}
</script>

<style lang="scss" scoped>
.document-container {
    max-width: 1000px;
    margin: 0 auto;
    // padding: 20px;
    font-family: "Microsoft YaHei", sans-serif;
    color: #000;
    line-height: 1.6;
}

.imageInfo {
    width: 800px;
    box-shadow: 0px 1px 20px #eeeeee;
    margin: 50px 0px;

    img {
        width: 100%;
    }
}
</style>